import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b467e4c4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b467e4c4&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b467e4c4')) {
      api.createRecord('b467e4c4', component.options)
    } else {
      api.reload('b467e4c4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b467e4c4&", function () {
      api.rerender('b467e4c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/self-procurement-register/index.vue"
export default component.exports